__turbopack_context__.v({
  "faqSection": "faq-section-module-scss-module__AeNw6q__faqSection",
  "faqSection_list": "faq-section-module-scss-module__AeNw6q__faqSection_list",
});
